<template>

<h1 class="header">Credits</h1>
  <p class="scala">--- CREDITS ---</p>
  <div class="textbox">
    <div class="text">
      <h3 class="group">KHSCALA SCRIPT FONT</h3>
      <p>Breezyfeather & Televo</p>
      <h3 class="group">PROOF OF FANTASY ICON</h3>
      <p>Kimpchuu</p>
      <h3 class="group">EVERYTHING ELSE</h3>
      <p>Televo</p>
    </div>
  </div>
  <h1 class="header">Special Thanks</h1>
  <p class="scala">--- SPECIAL THANKS ---</p>
  <div class="textbox">
    <div class="text">
      <h3 class="group">TRACKER ICON FEEDBACK</h3>
      <p>Zax, DA, 1234567890num, ZakTheRobot & TopazTK</p>
      <h3 class="group">KHSCALA TRANSLATION ASSISTANCE</h3>
      <p>Breezyfeather, iAyeCaptainKai & The Scala Survivors</p>
      <h3 class="group">REFERENCE IMAGERY RESOURCES</h3>
      <p @mousedown="playSelectSound"><a href="https://www.khwiki.com" target="_blank">Kingdom Hearts Wiki</a></p>
      <p @mousedown="playSelectSound"><a href="https://roboloid.github.io/khux/assets" target="_blank">Roboloid's Asset Gallery</a></p>
      <p @mousedown="playSelectSound"><a href="https://kh-stock.tumblr.com" target="_blank">KHNyctophiliac's KHStock</a></p>
      <h3 class="group">FINANCIAL SUPPORTERS</h3>
      <div class="supporters">
        <p>DA</p>
        <p>DJPRS</p>
        <p>DoubleADewi</p>
        <p>GhostTheBoo</p>
        <p>HG76</p>
        <p>iAyeCaptainKai</p>
        <p>Kayya</p>
        <p>Kité</p>
        <p>Raisin</p>
        <p>Roromaniac</p>
        <p>Sonzero</p>
        <p>TopazTK</p>
        <p>Timoram</p>
        <p>Xaddgx</p>
      </div>
    </div>
  </div>
</template>

<script>
import selectSound from "@/assets/audio/select.mp3";
import kupoSound from "@/assets/audio/kupo.mp3";
export default {
  name: 'SpecialThanks',
  methods: {
    playSelectSound() {
      const selectAudio = new Audio(selectSound);
      selectAudio.play();
    },
    playKupoSound() {
      const kupoAudio = new Audio(kupoSound);
      kupoAudio.play();
    },
  },
}
</script>

<style scoped>
.header {
  padding-top: 1em;
}
.text {
  padding-top: 0;
}
p {
  margin: 0;
}
.group {
  margin-top: 1.5em;
  color: var(--highlight);
  margin-bottom: 0.25em;
}
.supporters {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: center;
}
.supporters p:nth-child(odd) {
  text-align: right;
  padding-right: 1em;
}
.supporters p:nth-child(even) {
  text-align: left;
  padding-left: 1em;
}
</style>